/** Provider workspace cohort; controlled readers retain case-level authority. */
export const RTW_PROVIDER_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'OWNER',
  'CEO',
  'OPERATIONS_DIRECTOR',
  'HR_DIRECTOR',
  'HR_OFFICER',
  'FACILITY_MANAGER',
  'REGION_MANAGER',
] as const;
